import axios from "axios";
import { Module, Actions, Mutations, Getters } from "@/store/enums/hosterEnums";
import stc from "string-to-color";
import inviteDateModel from "@/core/models/hoster/inviteDate.interface";
import inviteInfoModel from "@/core/models/hoster/inviteInfo.interface";
import inviteDateCRUDModel from "@/core/models/hoster/inviteDateCRUD.interface";
import invitaDateTimeModel from "@/core/models/hoster/inviteDateTime.interface";
import inviteDateMsgModel from "@/core/models/hoster/inviteDateMsg.interface";

import userModel from "@/core/models/share/user.interface";
import locationModel from "@/core/models/share/location.interface";
import inviteEventModel from "@/core/models/share/inviteEvent.interface";
import invitePersonModel from "@/core/models/share/invitePerson.interface";
import inviteSchedulerModel from "@/core/models/share/inviteAvailableTime.interface";
import inviteSchedulerCountModel from "@/core/models/hoster/inviteAvailableTimeCount.interface";
import voteEventModel from "@/core/models/share/voteEvent.interface";
import statusModel from "@/core/models/share/status.interface";
import timelineRowGroupHeaderModel from "@/core/models/share/timeline/rowGroupHeader.interface";
import timelineRowHeaderModel from "@/core/models/share/timeline/rowHeader.interface";
import timelineElmtModel from "@/core/models/share/timeline/timelineItem.interface";
import searchPersonCRUDModel from "@/core/models/hoster/seachPersonCRUD.interface";

import { config } from "@/core/config";
import { useDayjs } from '@/core/hook/useDayjs';
const { dayjs } = useDayjs();
import ApiService from "@/core/services/ApiService";

import {
  EventStatus as ParamEventStatus,
  ParticapantStatus as ParamParticapantStatus,
  ResponseStatus as ParamResponseStatus,
  IsResolution as ParamIsResolution,
  HasReply as ParamHasReply,
} from "@/store/enums/paramsEnums";
import apiEnums from "@/core/services/apiEnums";
import { Params } from "../enums/participationEnums";

const BasicInfo: inviteInfoModel = {
  EventHeaderId: "",
  EventName: "",
  EventContext: "",
  Loaction: [],
  ReplayDealine: dayjs().add(1, "day").startOf("day").toDate().getTime(),
  Status: ParamEventStatus.Open,
};
const DateMsg: inviteDateMsgModel = {
  DateMsg: "",
  TimeMsg: "",
};

const hosterModules = {
  namespaced: true,
  state() {
    return {
      invitMember: new Array<invitePersonModel>(),
      inviteDate: new Array<inviteDateModel>(),
      inviteInfo: BasicInfo,
      inviteScheduler: new Array<inviteSchedulerModel>(),
      invitePerson: new Array<invitePersonModel>(),
      location: new Array<locationModel>(),
      keyWordPersonList: new Array<userModel>(),
      MyMemberId: "3d7f9a1c-1672-4b19-8be8-7b0d2fe1b3fd",
      eventResponse: new Array<voteEventModel>(),
      eventSchedularWithCount: new Array<inviteSchedulerCountModel>(),
      intervalMinutes: { data: Number(60) },
      inviteDateMessage: DateMsg,
      resolution: <inviteEventModel>{},
    };
  },

  mutations: {
    [Mutations.SetInVitMember](context: any, payload: invitePersonModel) {
      var email = payload;
      var isExist = false;
      context.invitMember.forEach((item: invitePersonModel, index: any) => {
        if (item.Email == payload.Email) {
          isExist = true;
        }
      });
      if (isExist == false) {
        context.keyWordPersonList.forEach(
          (item: invitePersonModel, index: any) => {
            if (item.Email == payload.Email && item.Cmpy == payload.Cmpy) {
              context.invitMember.push(item);
              //console.log("SetInVitMember", item);
            }
          }
        );
      }
    },
    [Mutations.RemoveInviteMember](context: any, payload: any) {
      context.invitMember.forEach((item: any, index: any) => {
        if (item === payload) context.invitMember.splice(index, 1);
      });
    },
    [Mutations.SetInviteDate](context: any, payload: Date) {
      var intervalMinutes = context.intervalMinutes.data;
      var startTime = dayjs(payload).add(8, "hour").valueOf();
      var endTime = dayjs(startTime).add(intervalMinutes, "minute").valueOf();
      var timeRanges = [
        0, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
      ];
      //  當天預設時間
      if (dayjs(payload).isSame(dayjs().startOf("day").toDate().getTime())) {
        startTime = dayjs().startOf("hour").toDate().getTime();
        endTime = dayjs(startTime).add(intervalMinutes, "minute").valueOf();
        timeRanges = [0];
        for (var i = dayjs().hour(); i <= 23; i++) {
          timeRanges.push(i);
        }
      }

      let TimeArray: invitaDateTimeModel = {
        TimeId: 1,
        StartTime: startTime,
        EndTime: endTime,
        TimeRanges: timeRanges,
      };
      let Data: inviteDateModel = {
        Date: payload,
        Time: [TimeArray],
      };
      let DateMsg: inviteDateMsgModel = {
        DateMsg: "",
        TimeMsg: "",
      };

      if (context.inviteDate.length <= 9) {
        context.inviteDate.push(Data);
        DateMsg.DateMsg = "";
      } else {
        // let DateMsg: inviteDateMsgModel = {
        //   DateMsg: "日期僅選10日",
        //   TimeMsg: "",
        // };
        // context.inviteDateMessage = DateMsg;
        DateMsg.DateMsg = "日期僅選10日";
      }
      context.inviteDateMessage = DateMsg;
    },
    [Mutations.RemoveInviteDate](context: any, payload: Date) {
      // 依據date 進行刪除動作
      context.inviteDate.forEach((item: inviteDateModel, index: any) => {
        if (item.Date.toString() === payload.toString()) {
          context.inviteDate.splice(index, 1);
        }
      });
      DateMsg.DateMsg = "";
      context.inviteDateMessage = DateMsg;
    },
    [Mutations.SetInviteDateTime](context: any, payload: inviteDateCRUDModel) {
      var intervalMinutes = context.intervalMinutes.data;
      var isDate = includeValue(payload.Date, context.inviteDate);
      function includeValue(
        stringValue: Date,
        arrayValue: Array<inviteDateModel>
      ) {
        for (let j = 0; j < arrayValue.length; j++) {
          if (stringValue.toString() == arrayValue[j].Date.toString()) {
            return true;
            break;
          }
        }
        return false;
      }
      if (isDate) {
        if (
          payload.Index == 0 &&
          payload.StartTime == 0 &&
          payload.EndTime == 0
        ) {
          //insert data time
          context.inviteDate.forEach((item: inviteDateModel, index: any) => {
            if (item.Date.toString() === payload.Date.toString()) {
              var lastId =
                context.inviteDate[index].Time[
                  context.inviteDate[index].Time.length - 1
                ].TimeId + 1;
              var startTime = dayjs(payload.Date).add(8, "hour").valueOf();
              var endTime = dayjs(startTime)
                .add(intervalMinutes, "minute")
                .valueOf();
              var timeRanges = [
                0, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
              ];

              //  當天預設時間
              if (
                dayjs(payload.Date).isSame(
                  dayjs().startOf("day").toDate().getTime()
                )
              ) {
                startTime = dayjs().startOf("hour").toDate().getTime();
                endTime = dayjs(startTime)
                  .add(intervalMinutes, "minute")
                  .valueOf();
                timeRanges = [0];
                for (var i = dayjs().hour(); i <= 23; i++) {
                  timeRanges.push(i);
                }
              }
              var Data: invitaDateTimeModel = {
                TimeId: lastId,
                StartTime: startTime,
                EndTime: endTime,
                TimeRanges: timeRanges,
              };
              let DateMsg: inviteDateMsgModel = {
                DateMsg: "",
                TimeMsg: "時間區段僅選7段",
              };

              if (context.inviteDate[index].Time.length <= 6) {
                context.inviteDate[index].Time.push(Data);
                DateMsg.TimeMsg = "";
              } else {
                DateMsg.TimeMsg = "時間區段僅選7段";
              }

              context.inviteDateMessage = DateMsg;
            }
          });
        } else if (
          payload.Index == 0 &&
          payload.StartTime != 0 &&
          payload.EndTime != 0
        ) {
          console.log(context.inviteDate)
          context.inviteDate.forEach((item: inviteDateModel, index: any) => {
            if (item.Date.toString() === payload.Date.toString()) {
              var lastId =
                context.inviteDate[index].Time[
                  context.inviteDate[index].Time.length - 1
                ].TimeId + 1;
              var Data = {
                TimeId: lastId,
                StartTime: payload.StartTime,
                EndTime: payload.EndTime,
              };
              //context.inviteDate[index].Time.push(Data);
              if (context.inviteDate[index].Time.length <= 6) {
                context.inviteDate[index].Time.push(Data);
              } else {
                let DateMsg: inviteDateMsgModel = {
                  DateMsg: "",
                  TimeMsg: "時間區段僅選7段",
                };
                context.inviteDateMessage = DateMsg;
              }
            }
          });
        } else if (
          payload.Index != 0 &&
          payload.StartTime != 0 &&
          payload.EndTime == 0
        ) {
          //update
          context.inviteDate.forEach((item: any, index: any) => {
            if (item.Date.toString() === payload.Date.toString()) {
              context.inviteDate[index].Time.forEach(
                (timeItem: any, TimeIndex: any) => {
                  if (timeItem.TimeId == payload.Index) {
                    var endTime = dayjs(payload.StartTime)
                      .add(intervalMinutes, "minute")
                      .valueOf();
                    var hourStart = dayjs(payload.StartTime).hour();
                    //update EndTime
                    context.inviteDate[index].Time[TimeIndex].EndTime = endTime;
                    // limit  TimeRanges
                    context.inviteDate[index].Time[TimeIndex].TimeRanges = [0];
                    for (var i = hourStart; i <= 23; i++) {
                      context.inviteDate[index].Time[TimeIndex].TimeRanges.push(
                        i
                      );
                    }
                  }
                }
              );
            }
          });
        } else if (
          payload.Index != 0 &&
          payload.StartTime != 0 &&
          payload.EndTime != 0
        ) {
          context.inviteDate.forEach((item: any, index: any) => {
            if (item.Date.toString() === payload.Date.toString()) {
              context.inviteDate[index].Time.forEach(
                (timeItem: any, TimeIndex: any) => {
                  if (timeItem.TimeId == payload.Index) {
                    //update StartTime
                    context.inviteDate[index].Time[TimeIndex].StartTime =
                      payload.StartTime;
                    //update EndTime
                    context.inviteDate[index].Time[TimeIndex].EndTime =
                      payload.EndTime;
                    // limit  TimeRanges
                    context.inviteDate[index].Time[TimeIndex].TimeRanges = [];
                    context.inviteDate[index].Time[TimeIndex].TimeRanges.push(
                      0
                    );
                    for (
                      var i = dayjs(payload.StartTime).hour();
                      i <= 23;
                      i++
                    ) {
                      context.inviteDate[index].Time[TimeIndex].TimeRanges.push(
                        i
                      );
                    }
                  }
                }
              );
            }
          });
        }
      } else {
        var startTime = dayjs(payload.Date).add(8, "hour").valueOf();
        var endTime = dayjs(startTime).add(2, "hour").valueOf();
        if (payload.StartTime != 0 && payload.EndTime == 0) {
          startTime = new Date(payload.StartTime).valueOf();
          endTime = dayjs(startTime).add(2, "hour").valueOf();
        } else if (payload.StartTime != 0 && payload.EndTime != 0) {
          startTime = new Date(payload.StartTime).valueOf();
          endTime = new Date(payload.EndTime).valueOf();
        }

        var TimeRangesList = [0];
        var hourStart = dayjs(startTime).hour();
        for (var i = hourStart; i <= 23; i++) {
          TimeRangesList.push(i);
        }

        let TimeArray: invitaDateTimeModel = {
          TimeId: 1,
          StartTime: startTime,
          EndTime: endTime,
          TimeRanges: TimeRangesList,
        };
        let Data: inviteDateModel = {
          Date: payload.Date,
          Time: [TimeArray],
        };

        let DateMsg: inviteDateMsgModel = {
          DateMsg: "",
          TimeMsg: "",
        };
        if (context.inviteDate.length <= 9) {
          context.inviteDate.push(Data);
          DateMsg.DateMsg = "";
        } else {
          DateMsg.DateMsg = "日期僅選10日";
        }
        context.inviteDateMessage = DateMsg;
      }
    },
    [Mutations.RemoveInviteDateTime](
      context: any,
      payload: inviteDateCRUDModel
    ) {
      // 依據date 進行刪除動作
      context.inviteDate.forEach((item: inviteDateModel, index: any) => {
        if (item.Date.toString() === payload.Date.toString()) {
          context.inviteDate[index].Time.forEach(
            (timeItem: any, TimeIndex: any) => {
              if (timeItem.TimeId == payload.Index) {
                context.inviteDate[index].Time.splice(TimeIndex, 1);
              }
            }
          );

          if (context.inviteDate[index].Time.length == 0) {
            context.inviteDate.splice(index, 1);
          }
        }
      });
      DateMsg.DateMsg = "";
      context.inviteDateMessage = DateMsg;
    },
    [Mutations.InitHosterData](context: any, data: Array<invitePersonModel>) {
      BasicInfo.EventName = "";
      BasicInfo.EventContext = "";
      BasicInfo.Loaction = [];
      (BasicInfo.ReplayDealine = dayjs()
        .add(7, "day")
        .startOf("day")
        .add(8, 'hours')
        .toDate()
        .getTime()),
        (context.inviteInfo = BasicInfo);
      context.invitMember = data;
      context.inviteDate = new Array<inviteDateModel>();
    },
    [Mutations.SetHosterData](context: any, payload: inviteEventModel) {
      BasicInfo.EventHeaderId = payload.EventHeaderId;
      BasicInfo.EventName = payload.Title;
      BasicInfo.EventContext = payload.Description;
      BasicInfo.Loaction = [];
      BasicInfo.ReplayDealine = dayjs(payload.SubmitDueDateUTCDateTime)
        .toDate()
        .getTime();
      BasicInfo.Status = payload.Status;
      context.inviteInfo = BasicInfo;
      context.invitMember = context.invitePerson;
      let DateData: Array<inviteDateModel> = [];
      context.inviteDate = DateData;
    },
    [Mutations.SetEventResponse](context: any, payload: Array<voteEventModel>) {
      context.eventResponse = payload;
      context.MyEventResponse = payload.filter(
        (r) => r.MemberId == context.MyMemberId
      );
    },
    [Mutations.SetEventSchedularWithCount](
      context: any,
      payload: Array<inviteSchedulerCountModel>
    ) {
      context.eventSchedularWithCount = payload;
    },
    [Mutations.SetInvitePerson](
      context: any,
      payload: Array<invitePersonModel>
    ) {
      context.invitePerson = payload;
    },
    [Mutations.SetInviteScheduler](
      context: any,
      payload: Array<inviteSchedulerModel>
    ) {
      context.inviteScheduler = payload;
    },
    [Mutations.SetLocation](context: any, payload: Array<locationModel>) {
      context.location = payload;
    },
    [Mutations.SetKeyWordPersonList](
      context: any,
      payload: { Search: Array<invitePersonModel>; Keyword: string }
    ) {
      let userData: invitePersonModel = {
        EventHeaderId: "",
        MemberId: "",
        Cmpy: "",
        UserId: "",
        Phone: "",
        Name: payload.Keyword.split("@")[0],
        Email: payload.Keyword,
        Comment: "",
        Permission: "",
        Status: "",
      };
      context.keyWordPersonList = payload.Search;
      var flag = "N";
      //WEBAPI 回傳是否有這筆資料
      payload.Search.forEach(
        (eleSearch: invitePersonModel, indexSearch: any) => {
          if (
            eleSearch.Email == userData.Email ||
            eleSearch.Name?.toUpperCase() == userData.Name?.toUpperCase() ||
            eleSearch.UserId?.toUpperCase() == userData.Name?.toUpperCase() ||
            eleSearch.Phone == userData.Name
          ) {
            flag = "Y";
          }


        }
      );

      var mailReg =
        /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      if (mailReg.test(userData.Email)) {
        //store.dispatch(Module.desc + Actions.HandInivteMember, param);
      } else {
        //message.error("未符合Email格式");
        flag = "Y";
      }
      //WEBAPI 回傳沒有這筆資料，則array第一筆資料進行insert
      if (flag == "N") {
        context.keyWordPersonList.unshift(userData);
      }
    },
    [Mutations.SetIntervalMinutes](context: any, payload: number) {
      context.intervalMinutes = payload;
    },
    [Mutations.SetResolution](context: any, payload: inviteEventModel) {
      context.resolution = payload;
    },
  },

  actions: {
    [Actions.HandInivteMember](context: any, member: invitePersonModel) {
      context.commit(Mutations.SetInVitMember, member);
    },
    [Actions.HandInivteMemberRemove](context: any, member: any) {
      context.commit(Mutations.RemoveInviteMember, member);
    },
    [Actions.HandInviteDate](context: any, date: inviteDateCRUDModel) {
      if (date.Action == "I") {
        context.commit(Mutations.SetInviteDate, date.Date);
      } else if (date.Action == "D") {
        context.commit(Mutations.RemoveInviteDate, date.Date);
      }
    },
    [Actions.HandInviteDateTime](context: any, time: inviteDateCRUDModel) {
      if (time.Action == "I") {
        context.commit(Mutations.SetInviteDateTime, time);
      } else if (time.Action == "D") {
        context.commit(Mutations.RemoveInviteDateTime, time);
      }
    },
    async [Actions.HandHosterAllData](context: any, data: inviteEventModel) {
      if (data.EventHeaderId == "0") {
        // 初始化人員列表，預設放入登入者
        var initPersonList = [
          <invitePersonModel>{
            EventHeaderId: "0",
            Name: context.rootState.user.Name,
            Email: context.rootState.user.Email,
            MemberId: context.rootState.user.MemberId,
          },
        ];
        await context.commit(Mutations.InitHosterData, initPersonList);
      } else if (data.EventHeaderId != "0") {
        // 根據 headerId 去取得人員
        var eventid = data.EventHeaderId;

        // 人員
        var endPoint: string =
          config.apiEndPoints.jma + apiEnums.GetEventParticipants.Path;
        await axios
          .get(
            endPoint.replace(
              apiEnums.GetEventParticipants.Params.eventid,
              eventid
            )
          )
          .then((response) => {
            // console.log("response: ", response.data);
            // console.log("----------------------------------------");
            context.commit(Mutations.SetInvitePerson, response.data);
          })
          .catch((error: any) => {
            console.log(
              error,
              " endpoint:",
              endPoint,
              " path:",
              endPoint.replace(config.apiEndPoints.jma, "")
            );
          });

        await context.commit(Mutations.SetHosterData, data);
      }
    },
    async [Actions.LoadEventResponse](context: any, eventid: string) {
      var endPoint = config.apiEndPoints.jma + apiEnums.GetEventResponses.Path;

      await axios
        .get(
          endPoint.replace(apiEnums.GetEventResponses.Params.eventid, eventid)
        )
        .then((response) => {
          // console.log("----------------------------------------");
          // console.log("response: ", response.data);
          context.commit(Mutations.SetEventResponse, response.data);
        })
        .catch((error: any) => {
          console.log(error);
          console.log({
            endpoint: endPoint,
            path: endPoint.replace(config.apiEndPoints.jma, ""),
          });
        });
    },
    async [Actions.LoadEventSchedularWithCount](context: any, eventid: string) {
      var endPoint =
        config.apiEndPoints.jma + apiEnums.GetEventSchedularSummaryByUser.Path;
      var memberid = context.rootState.user.MemberId;

      await axios
        .get(
          endPoint
            .replace(
              apiEnums.GetEventSchedularSummaryByUser.Params.eventid,
              eventid
            )
            .replace(
              apiEnums.GetEventSchedularSummaryByUser.Params.memberid,
              memberid
            )
        )
        .then((response) => {
          // console.log("response: ", response.data);
          // console.log("----------------------------------------");
          context.commit(Mutations.SetEventSchedularWithCount, response.data);
        })
        .catch((error: any) => {
          console.log(error);
          console.log({
            endpoint: endPoint,
            path: endPoint.replace(config.apiEndPoints.jma, ""),
          });
        });
    },
    async [Actions.LoadInvitePerson](context: any, eventid: string) {
      var endPoint =
        config.apiEndPoints.jma + apiEnums.GetEventParticipants.Path;
      eventid = eventid.toUpperCase();
      await axios
        .get(
          endPoint.replace(
            apiEnums.GetEventParticipants.Params.eventid,
            eventid
          )
        )
        .then((response) => {
          // console.log("response: ", response.data);
          // console.log("----------------------------------------");
          context.commit(Mutations.SetInvitePerson, response.data);
        })
        .catch((error: any) => {
          console.log(error);
          console.log({
            endpoint: endPoint,
            path: endPoint.replace(config.apiEndPoints.jma, ""),
          });
        });
    },
    async [Actions.LoadInviteScheduler](context: any, eventid: string) {
      var endPoint = config.apiEndPoints.jma + apiEnums.GetEventSchedulars.Path;

      await axios
        .get(
          endPoint.replace(apiEnums.GetEventSchedulars.Params.eventid, eventid)
        )
        .then((response) => {
          // console.log("response: ", response.data);
          // console.log("----------------------------------------");
          context.commit(Mutations.SetInviteScheduler, response.data);
        })
        .catch((error: any) => {
          console.log(error);
          console.log({
            endpoint: endPoint,
            path: endPoint.replace(config.apiEndPoints.jma, ""),
          });
        });
    },
    async [Actions.SubmitHosterDate](
      context: any,
      payload: {
        E: inviteEventModel;
        S: Array<inviteSchedulerModel>;
        P: Array<invitePersonModel>;
      }
    ) {
      // console.log(payload);
      var endPoint = "";
      var memberid = context.rootState.user.MemberId;
      var eventid = "";
      var addEventSuccess: Boolean = false;

      endPoint = config.apiEndPoints.jma + apiEnums.PostNewEvent.Path;

      if (
        dayjs(payload.E.SubmitDueDateUTCDateTime)
          .isSame(dayjs(payload.E.SubmitDueDateUTCDateTime), "day")
      ) {
        payload.E.SubmitDueDateUTCDateTime = dayjs(
          payload.E.SubmitDueDateUTCDateTime
        )

          .toISOString();
      }
      //設定時區
      payload.E.TimeOffset = dayjs().utcOffset();

      payload.E.HosterEmail = context.rootState.user.Email;
      payload.E.ApplierEmail = context.rootState.user.Email;
      //For Demo
      payload.E.HosterMemberId = context.rootState.user.MemberId;
      payload.E.HosterName = context.rootState.user.Name;
      payload.E.ApplierMemberId = context.rootState.user.MemberId;
      payload.E.ApplierName = context.rootState.user.Name;
      // 移除相同時段進 JMA API
      payload.S = [
        ...new Set(payload.S.map((item) => JSON.stringify(item))),
      ].map((item) => JSON.parse(item));
      // 移除相同starttime&endtime JMA API
      payload.S.forEach((item: any, index: any) => {
        if (item.ScheduleStartUTCDateTime === item.ScheduleEndUTCDateTime)
          payload.S.splice(index, 1);
      });
      await axios
        .post(
          endPoint.replace(apiEnums.PostNewEvent.Params.memberid, memberid),
          payload.E
          //ApiService.removeIndicateProperties(payload.E, ["EventHeaderId"])
        )
        .then((response) => {
          // console.log("----------------------------------------");
          // console.log("response: ", response);
          if (~~(response.status / 100) == 2) {
            let resDate: inviteEventModel = response.data;
            // console.log("resDate", resDate);
            eventid = resDate.EventHeaderId;
            addEventSuccess = true;
          }
        })
        .catch((error: any) => {
          console.log(error);
          console.log({
            endpoint: endPoint,
            path: endPoint.replace(config.apiEndPoints.jma, ""),
            request: payload.E,
            // request: ApiService.removeIndicateProperties(payload.E, [
            //   "EventHeaderId",
            // ]),
          });
        });

      if (addEventSuccess) {
        endPoint =
          config.apiEndPoints.jma + apiEnums.PostNewEventSchedulars.Path;
        //console.log(payload.S);

        await axios
          .post(
            endPoint.replace(
              apiEnums.PostNewEventSchedulars.Params.eventid,
              eventid
            ),
            payload.S
          )
          .then((response) => {
            //console.log("response: ", response.data);
            // if (~~(response.status / 100) == 2) {
            //   console.log("----------------------------------------");
            //   console.log(response.data);
            // }
          })
          .catch((error: any) => {
            console.log(error, {
              endpoint: endPoint,
              path: endPoint.replace(config.apiEndPoints.jma, ""),
              request: payload.S,
            });
          });

        endPoint = config.apiEndPoints.jma + apiEnums.PutEventParticipants.Path;
        await axios
          .put(
            endPoint.replace(
              apiEnums.PutEventParticipants.Params.eventid,
              eventid
            ),
            payload.P
          )
          .then((response) => {
            // console.log("response: ", response.data);
            // if (~~(response.status / 100) == 2) {
            //   console.log("----------------------------------------");
            //   console.log(response.data);
            // }
          })
          .catch((error: any) => {
            console.log(error, {
              endpoint: endPoint,
              path: endPoint.replace(config.apiEndPoints.jma, ""),
              request: payload.P,
            });
          });

        // 進行寄信
        endPoint = config.apiEndPoints.jma + apiEnums.SendMail.Path;
        await axios
          .put(endPoint.replace(apiEnums.SendMail.Params.eventid, eventid))
          .then((response) => {
            // console.log("response: ", response.data);
            // if (~~(response.status / 100) == 2) {
            //   console.log("----------------------------------------");
            //   console.log(response.data);
            // }
          })
          .catch((error: any) => {
            console.log(error, {
              endpoint: endPoint,
              path: endPoint.replace(config.apiEndPoints.jma, ""),
              request: payload.P,
            });
          });
      }
    },
    async [Actions.SearchPerson](context: any, keyWord: searchPersonCRUDModel) {
      //keyWord: {format:"",input:value}
      var endPoint =
        config.apiEndPoints.jma + apiEnums.SearchUserByKeyword.Path;
      await axios
        .get(
          endPoint.replace(
            apiEnums.SearchUserByKeyword.Params.keyword,
            keyWord.Data
          )
        )
        .then((response) => {
          // console.log("response: ", response);
          // console.log(apiEnums.SearchUserByKeyword.Path);
          // console.log("----------------------------------------");
          if (keyWord.IsOutlookFormat == false) {
            //當不符合格式，則塞入關鍵字下拉清單
            // console.log('1', response.data)
            // console.log('keyWord.Data', keyWord.Data)
            context.commit(Mutations.SetKeyWordPersonList, {
              Search: response.data,
              Keyword: keyWord.Data,
            });
          } else if (keyWord.IsOutlookFormat == true) {
            //當符合格式，則自動塞入資料SetInVitMember & 關鍵字下拉清單
            var splitList = keyWord.Data.split(";");
            let mailList = new Array<invitePersonModel>();
            splitList.forEach((element: any, index: any) => {
              var userData: invitePersonModel;
              if (element != "") {
                if (element.includes("<")) {
                  // 英文名[中文人名] <信箱>; 英文名[中文人名] <信箱>; 英文名[中文人名] <信箱>;
                  var splitEmail = element.split("<");
                  userData = {
                    Name: splitEmail[0],
                    Email: splitEmail[1].replace(">", ""),
                    EventHeaderId: "",
                    EventParticipantId: "",
                    MemberId: "",
                    Cmpy: "",
                    UserId: "",
                    Phone: "",
                    Comment: "",
                    Permission: "",
                    Status: "",
                  };
                } else {
                  // 信箱;信箱;信箱;
                  userData = {
                    Name: element.split("@")[0],
                    Email: element,
                    EventHeaderId: "",
                    EventParticipantId: "",
                    MemberId: "",
                    Cmpy: "",
                    UserId: "",
                    Phone: "",
                    Comment: "",
                    Permission: "",
                    Status: "",
                  };
                }
                mailList.push(userData);
              }
            });

            mailList.forEach((element: invitePersonModel, index: any) => {
              context.commit(Mutations.SetKeyWordPersonList, {
                Search: response.data,
                Keyword: element.Email,
              });
              context.commit(Mutations.SetInVitMember, element);
            });
          }
        })
        .catch((error: any) => {
          console.log(error);
          console.log({
            endpoint: endPoint,
            path: endPoint.replace(config.apiEndPoints.jma, ""),
          });
        });
    },
    async [Actions.UpdateHosterDate](
      context: any,
      payload: {
        E: inviteEventModel;
        S: Array<inviteSchedulerModel>;
        P: Array<invitePersonModel>;
      }
    ) {
      let endPoint = config.apiEndPoints.jma + apiEnums.PutEvent.Path;
      let eventid = payload.E.EventHeaderId;

      if (
        dayjs(payload.E.SubmitDueDateUTCDateTime)

          .isSame(dayjs(payload.E.SubmitDueDateUTCDateTime), "day")
      ) {
        payload.E.SubmitDueDateUTCDateTime = dayjs(
          payload.E.SubmitDueDateUTCDateTime
        )

          .toISOString();
      }
      //設定時區
      payload.E.TimeOffset = dayjs().utcOffset();

      payload.E.HosterEmail = context.rootState.user.Email;
      payload.E.ApplierEmail = context.rootState.user.Email;
      //For Demo
      payload.E.HosterMemberId = context.rootState.user.MemberId;
      payload.E.HosterName = context.rootState.user.Name;
      payload.E.ApplierMemberId = context.rootState.user.MemberId;
      payload.E.ApplierName = context.rootState.user.Name;
      //console.log("payload.E", payload.E);
      await axios
        .put(
          endPoint.replace(apiEnums.PutEvent.Params.eventid, eventid),
          payload.E
        )
        .then((response) => {
          if (~~(response.status / 100) == 2) {
            // console.log("----------------------------------------");
            // console.log("updateDate", response.data);
          }
        })
        .catch((error: any) => {
          console.log(error);
          console.log({
            endpoint: endPoint,
            path: endPoint.replace(config.apiEndPoints.jma, ""),
            request: payload.E,
          });
        });

      if (payload.P.length != 0) {
        endPoint = config.apiEndPoints.jma + apiEnums.PutEventParticipants.Path;
        await axios
          .put(
            endPoint.replace(
              apiEnums.PutEventParticipants.Params.eventid,
              eventid
            ),
            payload.P
          )
          .then((response) => {
            // console.log("response: ", response.data);
            if (~~(response.status / 100) == 2) {
              // console.log("----------------------------------------");
              // console.log(response.data);
            }
          })
          .catch((error: any) => {
            console.log(error);
            console.log({
              endpoint: endPoint,
              path: endPoint.replace(config.apiEndPoints.jma, ""),
              request: payload.P,
            });
          });
      }

      // 移除相同時段進 JMA API
      payload.S = [
        ...new Set(payload.S.map((item) => JSON.stringify(item))),
      ].map((item) => JSON.parse(item));
      // 移除相同starttime&endtime JMA API
      payload.S.forEach((item: any, index: any) => {
        if (item.ScheduleStartUTCDateTime === item.ScheduleEndUTCDateTime)
          payload.S.splice(index, 1);
      });
      //console.log("payload.S", payload.S);

      if (payload.S.length != 0) {
        endPoint =
          config.apiEndPoints.jma + apiEnums.PostNewEventSchedulars.Path;

        await axios
          .post(
            endPoint.replace(
              apiEnums.PostNewEventSchedulars.Params.eventid,
              eventid
            ),
            payload.S
          )
          .then((response) => {
            //console.log("response: ", response.data);
            // if (~~(response.status / 100) == 2) {
            //   console.log("----------------------------------------");
            //   console.log(response.data);
            // }
          })
          .catch((error: any) => {
            console.log(error, {
              endpoint: endPoint,
              path: endPoint.replace(config.apiEndPoints.jma, ""),
              request: payload.S,
            });
          });
      }

      // 進行寄信
      endPoint = config.apiEndPoints.jma + apiEnums.SendMail.Path;
      await axios
        .put(endPoint.replace(apiEnums.SendMail.Params.eventid, eventid))
        .then((response) => {
          // console.log("response: ", response.data);
          // if (~~(response.status / 100) == 2) {
          //   console.log("----------------------------------------");
          //   console.log(response.data);
          // }
        })
        .catch((error: any) => {
          console.log(error, {
            endpoint: endPoint,
            path: endPoint.replace(config.apiEndPoints.jma, ""),
            request: payload.P,
          });
        });

    },
    [Actions.HandIntervalMinutes](context: any, intervalMinutes: number) {
      context.commit(Mutations.SetIntervalMinutes, intervalMinutes);
    },
    [Actions.UpdateResolution](context: any, data: inviteEventModel) {
      context.commit(Mutations.SetResolution, data);
    },
    [Actions.ResetResolution](context: any, data: inviteEventModel) {
      //console.log(Actions.ResetResolution, data)
      data.Location = "";
      data.FianlSchedularId = "";
      data.StartUTCDateTime = "";
      data.EndUTCDateTime = "";
      context.commit(Mutations.SetResolution, data);
    },
    async [Actions.SubmitResolution](context: any, data: inviteEventModel) {
      var memberid = context.rootState.user.MemberId;
      var endPoint = config.apiEndPoints.jma + apiEnums.PutEvent.Path;
      var eventid = data.EventHeaderId;
      //設定時區
      data.TimeOffset = dayjs().utcOffset();

      data.HosterEmail = context.rootState.user.Email;
      data.ApplierEmail = context.rootState.user.Email;
      //For Demo
      data.HosterMemberId = context.rootState.user.MemberId;
      data.HosterName = context.rootState.user.Name;
      data.ApplierMemberId = context.rootState.user.MemberId;
      data.ApplierName = context.rootState.user.Name;

      data.Status = ParamEventStatus.Close;
      data.IsResolution = ParamIsResolution.Done;

      await axios
        .put(endPoint.replace(apiEnums.PutEvent.Params.eventid, eventid), data)
        .then((response) => {
          if (~~(response.status / 100) == 2) {
            console.log(response);
            // console.log("----------------------------------------");
            // console.log("updateDate", response.data);
            data.FianlSchedularId = "";
            data.Location = "";
            data.StartUTCDateTime = "";
            data.EndUTCDateTime = "";
            context.commit(Mutations.SetResolution, data);
          }
        })
        .catch((error: any) => {
          console.log(error);
          console.log({
            endpoint: endPoint,
            path: endPoint.replace(config.apiEndPoints.jma, ""),
            request: data,
          });
        });

      // 進行寄信
      endPoint = config.apiEndPoints.jma + apiEnums.SendMail.Path;
      await axios
        .put(endPoint.replace(apiEnums.SendMail.Params.eventid, eventid))
        .then((response) => {
          console.log("response: ", response);

        })



    },
  },
  getters: {
    [Getters.IntervalMinutes](context: any) {
      return context.intervalMinutes;
    },
    [Getters.InvitMember](context: any) {
      return context.invitMember;
    },
    [Getters.InviteDate](context: any) {
      // return context.inviteDate;
      let result = <Array<inviteDateModel>>(context.inviteDate ?? []);

      result = result.sort(function (a1, a2) {
        return a1.Date > a2.Date ? 1 : -1;
      });

      return result;
    },
    [Getters.InviteDateList](context: any) {
      let list: string[] = [];
      context.inviteDate.forEach((item: any, index: any) => {
        list.push(item.Date);
      });
      return list;
    },
    [Getters.InviteInfo](context: any) {
      return context.inviteInfo;
    },
    [Getters.EventResponse](context: any) {
      return context.eventResponse;
    },
    [Getters.Location](context: any) {
      let list: any[] = [];
      context.location.forEach((item: any, index: any) => {
        var temp = {
          label: item.Value,
          value: item.Value,
          memberId: item.Value,
        };
        list.push(temp);
      });

      return list;
    },
    [Getters.InvitePerson](context: any) {
      return context.invitePerson;
    },
    [Getters.InviteScheduler](context: any) {
      let DateData: Array<inviteDateModel> = [];
      function includeValue(
        stringValue: Date,
        arrayValue: Array<inviteDateModel>
      ) {
        for (let j = 0; j < arrayValue.length; j++) {
          if (dayjs(stringValue).isSame(arrayValue[j].Date, "date")) {
            return true;
            break;
          }
        }
        return false;
      }
      context.inviteScheduler.forEach(
        (item: inviteSchedulerModel, index: any) => {
          var isIncludeDate = includeValue(
            dayjs(item.ScheduleStartUTCDateTime).toDate(),
            DateData
          );
          if (!isIncludeDate) {
            let tempTimeData: invitaDateTimeModel = {
              TimeId: 0,
              StartTime: dayjs(item.ScheduleStartUTCDateTime).valueOf(),
              EndTime: dayjs(item.ScheduleEndUTCDateTime).valueOf(),
              TimeRanges: [0],
            };
            var hourStart = dayjs(item.ScheduleStartUTCDateTime).hour();
            for (var i = hourStart; i <= 23; i++) {
              tempTimeData.TimeRanges.push(i);
            }
            var tempDate: inviteDateModel = {
              Date: dayjs(item.ScheduleStartUTCDateTime).toDate(),
              Time: [tempTimeData],
            };
            DateData.push(tempDate);
          } else {
            let tempTimeData: invitaDateTimeModel = {
              TimeId: 0,
              StartTime: dayjs(item.ScheduleStartUTCDateTime).valueOf(),
              EndTime: dayjs(item.ScheduleEndUTCDateTime).valueOf(),
              TimeRanges: [0],
            };
            var hourStart = dayjs(item.ScheduleStartUTCDateTime).hour();
            for (var i = hourStart; i <= 23; i++) {
              tempTimeData.TimeRanges.push(i);
            }

            DateData.forEach((itemData: inviteDateModel, indexData: any) => {
              if (
                dayjs(itemData.Date).isSame(
                  item.ScheduleStartUTCDateTime,
                  "date"
                )
              ) {
                tempTimeData.TimeId = itemData.Time.length + 1;
                itemData.Time.push(tempTimeData);
              }
            });
          }
        }
      );

      return DateData;
    },
    [Getters.KeywordPersonList](context: any) {
      let list: any[] = [];
      context.keyWordPersonList.forEach(
        (item: invitePersonModel, index: any) => {
          //var temp = { label: item.Name, value: item.Name };
          if (item.UserId != "") {
            if (item.Phone == "*") {
              var temp = {
                label:
                  item.Name +
                  " " +
                  item.UserId +
                  "(" +
                  item.Email +
                  ") " +
                  item.Cmpy,
                value: item,
              };
            } else {
              var temp = {
                label:
                  item.Name +
                  " " +
                  item.UserId +
                  "(" +
                  item.Email +
                  ")" +
                  "#" +
                  item.Phone +
                  " " +
                  item.Cmpy,
                value: item,
              };
            }
          } else {
            var temp = {
              label: item.Name + "(" + item.Email + ")",
              value: item,
            };
          }

          list.push(temp);
        }
      );
      //var temp = { label: item.Name, value: item.Name, memberId: item.MemberId, email: item.Email };
      return list;
    },
    [Getters.InviteDateMessage](context: any) {
      return context.inviteDateMessage;
    },
    [Getters.TimelineRowGroupHeaderList]:
      (context: any) => (ori: Array<statusModel>) => {
        let result = <Array<timelineRowGroupHeaderModel>>ori.map(function (
          status: statusModel
        ) {
          let item = <timelineRowGroupHeaderModel>{
            Text: status.Name,
            Value: status.Value,
            ShowDetail: true,
            StyleColor: stc(status.EventStatusId),
          };

          return item;
        });
        return result;
      },
    [Getters.TimelineRowHeaderList](context: any) {
      let result = <Array<timelineRowHeaderModel>>(
        context.invitePerson ?? []
      ).map(function (user: invitePersonModel) {
        let item = <timelineRowHeaderModel>{
          Text: user.Name,
          Value: user.EventParticipantId?.toUpperCase(),
          Group: user.Status,
          StyleColor: stc(user.MemberId),
        };

        return item;
      });
      return result;
    },
    [Getters.TimelineDataList]:
      (context: any) => (showDay: number, baseDate: Date) => {
        let resArray = <Array<timelineElmtModel>>[];
        let day = baseDate.getDay();
        let diff = baseDate.getDate() - day + (day == 0 ? -6 : 1);
        let theFirstDate = new Date(
          new Date(baseDate).setDate(diff)
        ).toISOString();
        let theLastDate = new Date(
          new Date(baseDate).setDate(diff) + (showDay - 1) * 86400000
        ).toISOString();

        let pointer: number = 0;
        let counter: number = 0;
        let currentafter: boolean = false;
        let currentbefore: boolean = false;
        let size =
          dayjs(theLastDate)
            .startOf("day")
            .diff(dayjs(theFirstDate).startOf("day"), "day") + 1;
        let tempId = "";
        let localUserResponse = context.eventResponse.map(
          (a: voteEventModel) => {
            return { ...a };
          }
        );
        localUserResponse.sort(function (a: voteEventModel, b: voteEventModel) {
          if (a.EventParticipantId === b.EventParticipantId) {
            return a.ScheduleStartUTCDateTime < b.ScheduleStartUTCDateTime
              ? -1
              : 1;
          } else {
            return a.EventParticipantId < b.EventParticipantId ? -1 : 1;
          }
        });

        resArray.push({});
        localUserResponse.forEach(function (elmt: voteEventModel) {
          if (elmt.Status == ParamResponseStatus.Agree) {
            let id = elmt.EventParticipantId.toUpperCase();

            if (tempId != id) {
              pointer = 0;
              counter = 0;
              currentafter = false;
              currentbefore = false;
              tempId = id;
              resArray[0][id] = {};
            }

            //確認EVENT存在，且該狀態不是結束
            if (
              dayjs(elmt.ScheduleStartUTCDateTime).isBefore(
                theLastDate,
                "day"
              ) &&
              dayjs(elmt.ScheduleEndUTCDateTime).isSameOrAfter(
                theFirstDate,
                "day"
              )
            ) {
              let dx: number = dayjs(elmt.ScheduleStartUTCDateTime).isBefore(
                theFirstDate,
                "day"
              )
                ? 0
                : dayjs(elmt.ScheduleStartUTCDateTime)
                  .startOf("day")
                  .diff(dayjs(theFirstDate).startOf("day"), "day");
              let cnt: number =
                dayjs(
                  dayjs(elmt.ScheduleEndUTCDateTime).isAfter(
                    theLastDate,
                    "day"
                  )
                    ? theLastDate
                    : elmt.ScheduleEndUTCDateTime
                )
                  .startOf("day")
                  .diff(
                    dayjs(
                      dayjs(elmt.ScheduleStartUTCDateTime).isBefore(
                        theFirstDate,
                        "day"
                      )
                        ? theFirstDate
                        : elmt.ScheduleStartUTCDateTime
                    ).startOf("day"),
                    "day"
                  ) + 1;
              let after: boolean = dayjs(elmt.ScheduleEndUTCDateTime).isAfter(
                theLastDate,
                "day"
              );
              let before: boolean = dayjs(
                elmt.ScheduleStartUTCDateTime
              ).isBefore(theFirstDate, "day");

              if (dx > pointer + counter) {
                pointer = dx;
                counter = cnt;
                currentafter = after;
                currentbefore = before;
              } else {
                cnt = dx + cnt - pointer;
                if (counter < cnt) counter = cnt;
                else cnt = counter;
                dx = pointer;
                currentafter = currentafter || after;
                currentbefore = currentbefore || before;
              }

              if (counter + dx > size) {
                counter = size - dx;
              }

              resArray[0][id][dx] = {
                choice: <
                  {
                    length: number;
                    isBefore: boolean;
                    isAfter: boolean;
                    isAlpha: boolean;
                  }
                  >{
                    length: counter,
                    isAfter: currentafter,
                    isBefore: currentbefore,
                    isAlpha: false,
                  },
              };
            }
          }
        });
        return resArray;
      },
    [Getters.EventSchedularWithCount](context: any) {
      let result = <Array<inviteSchedulerCountModel>>(
        (context.eventSchedularWithCount ?? [])
      );

      result = result.sort(function (a, b) {
        if (a.AgreeCount != b.AgreeCount) {
          return a.AgreeCount < b.AgreeCount ? 1 : -1;
        }

        return a.ScheduleStartUTCDateTime > b.ScheduleStartUTCDateTime ? 1 : -1;
      });
      return result;
    },
    [Getters.Resolution](context: any) {
      return context.resolution;
    },
  },
};

export { Module, hosterModules };
